import type { useTranslation } from "react-i18next";

import {
  HTTP_BAD_GATEWAY,
  HTTP_FORBIDDEN,
  HTTP_UNAUTHORIZED,
  HTTP_UNPROCESSABLE_ENTITY,
} from "./api";
import {
  TRACKER_CREDENTIALS_REJECTED_DETAIL,
  TRACKER_HOST_NOT_ALLOWED_DETAIL,
  TrackerRequestError,
} from "./taskTrackerApi";

// Человекочитаемый текст отказа `verify`/`PUT`/`DELETE`/`status`
// трекера задач. Пять кодов контракта (ADR-0075 § 3) различаются по
// `status` и, для `401`/`403`, по точной строке `detail`: отказ трекера
// против истёкшей сессии Baton (`401`) и allowlist против RBAC
// (`core/rbac`, `403`).
export function describeTrackerError(
  err: unknown,
  t: ReturnType<typeof useTranslation>["t"],
): string {
  if (err instanceof TrackerRequestError) {
    if (
      err.status === HTTP_UNAUTHORIZED &&
      err.detail === TRACKER_CREDENTIALS_REJECTED_DETAIL
    ) {
      return t("connections.taskTracker.errors.credentialsRejected");
    }
    if (err.status === HTTP_UNAUTHORIZED) {
      return t("connections.taskTracker.errors.sessionExpired");
    }
    if (
      err.status === HTTP_FORBIDDEN &&
      err.detail === TRACKER_HOST_NOT_ALLOWED_DETAIL
    ) {
      return t("connections.taskTracker.errors.hostNotAllowed");
    }
    if (err.status === HTTP_FORBIDDEN) {
      return t("connections.taskTracker.errors.forbidden");
    }
    if (err.status === HTTP_UNPROCESSABLE_ENTITY) {
      return t("connections.taskTracker.errors.invalidInput");
    }
    if (err.status === HTTP_BAD_GATEWAY) {
      return t("connections.taskTracker.errors.unreachable");
    }
  }
  const message = err instanceof Error ? err.message : String(err);
  return t("connections.genericError", { message });
}

/**
 * Снять один хвостовой `/` и пробелы по краям — для сравнения с
 * сохранённым `host_url`, который backend нормализует так же (несколько
 * хвостовых `/` backend отвергает как пустой сегмент пути). Используется
 * только для предупреждения о смене хоста, не для тела запроса:
 * обрезку хвостового `/` делает backend.
 */
export function normalizeHostUrl(value: string): string {
  return value.trim().replace(/\/$/, "");
}
